<form
  [formGroup]="activityFormService.activityForm"
  class="flex flex-col gap-4"
>
  <h4 class="text-primary-900">
    {{ "prestation.passengerPerVehicle.title" | transloco }}
  </h4>
  <div class="flex flex-1 flex-col">
    <label for="distance" class="text-paragraph-xs-med text-greyscale-700">
      {{ "prestation.passengerPerVehicle.description" | transloco }}
    </label>
    <p-inputNumber
      id="distance"
      formControlName="peoplePerVehicle"
      [fluid]="true"
    />
    <app-error
      [control]="activityFormService.activityForm.get('peoplePerVehicle')!"
    />
  </div>
</form>
